import React from 'react';
import { useState, useEffect } from 'react';
import { STATUS_NONE } from '../../../api/billing';
import PropTypes from 'prop-types';
import PermissionDenied from '../../../components/PermissionDenied';
import Container from '@material-ui/core/Container';
import Page from '../../../components/Page';
import { BillingAPI } from '../../../api';
import CardPayment from '../../../components/braintree/CardPayment';
import PlanCardGroup from '../../auth/components/PlanCardGroup';
import PlanSummary from '../../auth/components/PlanSummary';
import Markdown from '../../../components/Markdown';
import Alert from '@material-ui/lab/Alert';
import { useSelector } from 'react-redux';
import { hasPermission, EDIT_BILLING } from '../../../lib/permissions';
import { makeStyles } from '@material-ui/core/styles';
import { useContent } from '../../../components/ContentProvider';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
  planRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cardPayment: {
    marginBottom: '2rem',
    maxWidth: 600,
  },
});

const AdminPage = ({match}) => {
  const content = useContent('/providers/signup/') || {};
  const history = useHistory();
  const [plans, setPlans] = useState();
  const [subscription, setSubscription] = useState();
  const [planId, setPlanId] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [busy, setBusy] = useState(false);
  const plan = plans && plans.find(({ id }) => id === planId);
  const providerUuid = match.params.uuid;
  const profile = useSelector(state => state.auth.profile);
  const hasPagePermission = hasPermission(profile, providerUuid, EDIT_BILLING);
  const allowFreeTrial = subscription && subscription.status === STATUS_NONE;
  const classes = useStyles();

  const submitPayment = async (paymentMethodNonce) => {
    setBusy(true);
    setErrorMessage();
    try {
      await BillingAPI.createSubscription(providerUuid, paymentMethodNonce, planId);
      history.replace(`/provider/${providerUuid}/admin/billing`);
    } catch(err) {
      setBusy(false);
      if (err.body) {
        const { message } = err.body;
        setErrorMessage(message);
      } else {
        setErrorMessage('An error occurred updating your profile.');
      }
    }
  };

  useEffect(()=> {
    const getPlans = async() => {
      const { payload: { plans }} = await BillingAPI.getPlans();
      setPlans(plans);
      setPlanId(plans[0].id);  // set default plan to first plan
    };
    const getSubscription = async() => {
      const { payload: { subscription }} = await BillingAPI.getSubscription(providerUuid);
      setSubscription(subscription);
    };
    getPlans();
    getSubscription();
  }, [providerUuid]);

  if (!hasPagePermission) {
    return <PermissionDenied/>;
  }

  return (
    <Page title="Get Accredited - Clickability">
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Markdown content={allowFreeTrial ? content.paymentheader : content.paymentheaderwithouttrial}/>
        {plans && planId && <PlanCardGroup plans={plans} planId={planId} onChange={setPlanId}/>}
        <CardPayment
          providerUuid={providerUuid}
          onComplete={({billing_payment_method_nonce}) => submitPayment(billing_payment_method_nonce)}
          onError={setErrorMessage}
          anonymous={true}
          buttonLabel="Submit Now"
          footer={plan && <PlanSummary plan={plan} allowFreeTrial={allowFreeTrial}/>}
          busy={busy}
          className={classes.cardPayment}
          allowDelete={false}
        />
        <Markdown content={allowFreeTrial ? content.paymentfooter : content.paymentfooterwithouttrial}/>
        {errorMessage &&
          <Alert severity="error" className={classes.alert}>
            {errorMessage}
          </Alert>
        }
      </Container>
    </Page>
  );
};

AdminPage.propTypes = {
  match: PropTypes.object.isRequired,
};

export default AdminPage;
